var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({on:{"keydown":_vm.validateInput},model:{value:(_vm.formattedTime),callback:function ($$v) {_vm.formattedTime=$$v},expression:"formattedTime"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }